// src/utils/date-utils/make-utc-date.ts
const makeUtcDate = (dateTime: string): Date | undefined => {
  if (typeof dateTime !== "string") {
    return undefined;
  }

  const datePart = dateTime.split("T")[0];
  const dateObj = new Date(datePart);

  if (Number.isNaN(dateObj.getTime())) {
    return undefined;
  }

  return new Date(Date.UTC(
    dateObj.getUTCFullYear(),
    dateObj.getUTCMonth(),
    dateObj.getUTCDate(),
    0,
    0,
    0
  ));
};

export default makeUtcDate;